(function () {
  var row = document.querySelector('[data-product-row]');
  if (!row) return;
  function step(dir) {
    var card = row.firstElementChild;
    var width = card ? card.offsetWidth + 16 : 240;
    row.scrollBy({ left: dir * width * 2, behavior: 'smooth' });
  }
  var next = document.querySelector('[data-row-next]');
  var prev = document.querySelector('[data-row-prev]');
  if (next) next.addEventListener('click', function () { step(1); });
  if (prev) prev.addEventListener('click', function () { step(-1); });
})();
